export default "__VITE_ASSET__29e1b6b2__"